/** fileName: MasterReducer.js
 * developer: majid.garavand@gmail.com
 * created: 3/17/23
 * note: Do not delete this comment to maintain copyright rules
 * */
const PREFIX = "@SET_STATE/";

const MasterReducer = (state = {}, action) => {
    if (action?.type?.startsWith(PREFIX)) {
        const keyName = action.type.replace(PREFIX, "");
        return {
            ...state,
            [keyName]: action.payload
        };
    }
    return state;
};

export default MasterReducer;
